import statisticService from '../services/statisticsService';

export const loadStatistics = async (releaseId, setStats) => {
  const data = await statisticService.fetchReleaseStatistics(releaseId);
  setStats(data);
};

export const loadMagazineStats = async (magazineId, setStats) => {
  const data = await statisticService.fetchMagazineStatistics(magazineId);
  setStats(data);
};

export const loadSubscriberStats = async (magazineId, setStats) => {
  const data = await statisticService.loadSubscriberStats(magazineId, setStats);
  setStats(data);
};

export const loadStats = async (magazineId, setStats) => {
  const data = await statisticService.loadStatistcStats(magazineId, setStats);
  setStats(data);
};

export const getReleaseStatsByAction = async (params, setState) => {
  const result = await statisticService.getReleaseStatisticsByAction(params);
  if (result && result.status) {
    setState({
     subscribers: result.data.data || [],
      perPage: Number(result.data.per_page),
      total: result.data.total,
      releaseId: params.releaseId,
      action: params.action,
      current_page: result.data.current_page,
      page: result.data.current_page,
    });
  } else {
    console.error('Failed to fetch releases');
  }
};